import { render, staticRenderFns } from "./supplierInformation.vue?vue&type=template&id=677dbf76&scoped=true"
import script from "./supplierInformation.vue?vue&type=script&lang=js"
export * from "./supplierInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677dbf76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/prod-www.dijie360.com-nginx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('677dbf76')) {
      api.createRecord('677dbf76', component.options)
    } else {
      api.reload('677dbf76', component.options)
    }
    module.hot.accept("./supplierInformation.vue?vue&type=template&id=677dbf76&scoped=true", function () {
      api.rerender('677dbf76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mechanism/components/myDealChild/child/orderDetailChild/supplierInformation.vue"
export default component.exports